<template>
  <div>
    <router-link v-if="customSurveys.length === 1" :to="{ name: 'CompaniesCustomSurveyAnswers', params: { company_uuid: currentCompanyUuid }, query: { ...formValues, query: keyword, custom_survey_id: customSurveys[0].id }}">
      {{ $t('pages.companies.analysis.keywords.labels.types.customSurveyStoreAnswer', { count: customSurveyAnswerCount }) }}
    </router-link>
    <span v-else-if="customSurveys.length === 0">
      {{ $t('pages.companies.analysis.keywords.labels.types.customSurveyStoreAnswer', { count: customSurveyAnswerCount }) }}
    </span>
    <span v-else class="dropDownLink" @click="isOpenDropDown = true">
      {{ $t('pages.companies.analysis.keywords.labels.types.customSurveyStoreAnswer', { count: customSurveyAnswerCount }) }}
      <Icon name="iconChevronDown" />
    </span>
    <div class="dropDownWrapper">
      <div v-if="isOpenDropDown" class="dropDownList">
        <template v-for="survey in customSurveys" :key="survey.id">
          <router-link class="listItem" :to="{ name: 'CompaniesCustomSurveyAnswers', params: { company_uuid: currentCompanyUuid }, query: { ...formValues, query: keyword, custom_survey_id: survey.id }}">
            {{ $t('pages.companies.analysis.keywords.labels.customSurvey', { count: survey.count, surveyName: survey.name }) }}
          </router-link>
        </template>
      </div>
    </div>
    <div v-if="isOpenDropDown" class="dropdownBackground" @click="isOpenDropDown = false" />
  </div>
</template>

<script>
import Icon from '../../Icon'

export default {
  name: 'CustomSurveyLink',
  components: {
    Icon
  },
  props: {
    currentCompanyUuid: {
      type: String,
      required: true
    },
    keyword: {
      type: String,
      required: true
    } ,
    customSurveys: {
      type: Array,
      default: () => []
    },
    formValues: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpenDropDown: false
    }
  },
  computed: {
    customSurveyAnswerCount() {
      return this.customSurveys
        .map((survey) => survey.count)
        .reduce((sum, element) => sum + element, 0)
        .toLocaleString()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';
.dropDownLink {
  color: $color-font-base;
  text-decoration: underline;
  word-break: break-all;
  cursor: pointer;
}
.dropdownBackground {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100vw;
  height: 100vh;
}
.dropDownWrapper {
  position: relative;
}
.dropDownList {
  position: absolute;
  z-index: 3;
  min-width: 220px;
  max-height: 300px;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, .05);
  background-color: $color-base-a;
  transition: .2s;
  .listItem {
    display: flex;
    position: relative;
    align-items: center;
    min-height: 48px;
    padding: 6px 24px;
    color: $color-font-base;
    white-space: nowrap;
    transition: .2s;
    text-decoration: none;
    &:not(.active):hover {
      background-color: $color-base-f;
      cursor: pointer;
    }
  }
}
</style>
